import type { SVGProps } from 'react';
const DawnFlagLC = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-LC_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-LC_svg__a)">
      <path fill="#86D7FF" d="M0 0h22v16H0z" />
      <g filter="url(#dawn-flag-LC_svg__b)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m11 2.133 4.715 11.734H6.286z"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#262626"
        fillRule="evenodd"
        d="m11 4.267 3.666 9.6H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#FFDA57"
        fillRule="evenodd"
        d="m11 7.467 4.715 6.4H6.286z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="dawn-flag-LC_svg__b"
        width={9.429}
        height={12.733}
        x={6.286}
        y={2.133}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1117" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1117" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagLC;
